import { Box, Button, Flex } from '../../../../../../../../../mads';
import { useI18n } from '../../../../../../../../../shared/I18n';
import { useViewjobOneGraphModel } from '../../../../../../../context/ViewJobDataContext';
import { useFullScreenVJActive } from '../../../../../../../hooks/useFullScreenVJActive';
import InlineQuestionResponse from '../../../../types/InlineQuestionResponse';

import { colors } from '@indeed/ifl-tokens';
import React from 'react';
import { StyleSheet } from 'react-native';


const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    buttonWrapper: {
        flex: 1,
    },
    divider: {
        width: 1,
        height: 24,
        backgroundColor: colors.neutral[300],
    },
});

export const InlineResponseButtons: React.FunctionComponent<{
    label: string;
    onClick: (response: InlineQuestionResponse) => void;
}> = ({ label, onClick }) => {
    const { gettext } = useI18n();
    const viewjobOneGraphModel = useViewjobOneGraphModel();
    const loggedIn = viewjobOneGraphModel?.jobSeeker?.isLoggedIn;
    const isFullScreenVJActive = useFullScreenVJActive();
    const handleOnClick = (response: InlineQuestionResponse) => {
        // JMUI find solution for web events
        // e.preventDefault();
        onClick(response);
    };

    if (isFullScreenVJActive) {
        return (
            <Box accessibilityRole="radiogroup">
                <Box sx={styles.container}>
                    <Box sx={styles.buttonWrapper}>
                        <Button
                            size="md"
                            variant="tertiary"
                            testID={`${label}-yes`}
                            onPress={() => handleOnClick(InlineQuestionResponse.YES)}
                            accessibilityRole="radio"
                        >
                            {gettext('Yes')}
                        </Button>
                    </Box>
                    <Box sx={styles.divider} />
                    <Box sx={styles.buttonWrapper}>
                        <Button
                            size="md"
                            variant="tertiary"
                            testID={`${label}-no`}
                            onPress={() => handleOnClick(InlineQuestionResponse.NO)}
                            accessibilityRole="radio"
                        >
                            {gettext('No')}
                        </Button>
                    </Box>
                    {loggedIn && (
                        <>
                            <Box sx={styles.divider} />
                            <Box sx={styles.buttonWrapper}>
                                <Button
                                    size="md"
                                    variant="tertiary"
                                    testID={`${label}-skip`}
                                    onPress={() => handleOnClick(InlineQuestionResponse.SKIP)}
                                    accessibilityRole="radio"
                                >
                                    {gettext('Skip')}
                                </Button>
                            </Box>
                        </>
                    )}
                </Box>
            </Box>
        );
    }

    return (
        <Box accessibilityRole="radiogroup">
            <Flex
                sx={{
                    justifyContent: loggedIn ? 'flex-start' : 'flex-end',
                    flexDirection: 'row',
                    gap: 4,
                    flexShrink: 1,
                    flexGrow: 0,
                    marginTop: loggedIn ? 2 : 0,
                }}
            >
                <Button
                    size="md"
                    variant="secondary"
                    testID={`${label}-yes`}
                    onPress={() => handleOnClick(InlineQuestionResponse.YES)}
                    accessibilityRole="radio"
                >
                    {gettext('Yes')}
                </Button>
                <Button
                    size="md"
                    variant="secondary"
                    testID={`${label}-no`}
                    onPress={() => handleOnClick(InlineQuestionResponse.NO)}
                    accessibilityRole="radio"
                >
                    {gettext('No')}
                </Button>
                {loggedIn && (
                    <Button
                        size="md"
                        variant={'secondary'}
                        testID={`${label}-skip`}
                        onPress={() => handleOnClick(InlineQuestionResponse.SKIP)}
                        accessibilityRole="radio"
                    >
                        {gettext('Skip')}
                    </Button>
                )}
            </Flex>
        </Box>
    );
};
